
export const ApplicationFeatures = [
    'Organization',
    'Locations',

    'Meeting',
    'AnnualStatus',
    'WorkplaceAssessment',
    'SafetyInspection',
    'CustomForms',
    'Articles',
    'ArticlesLight',
    'ArticleLandingPage',
    'Learning',
    'ActionPlans',
    'ExternalLinks',
    'DocumentArchive',
    'Incidents',
    'Notifications',
    'EmployeePortal',
    'PublicArticles'
] as const;

export type ApplicationFeature = typeof ApplicationFeatures[number];

export const DefaultApplicationFeatures:ApplicationFeature[] = [
    'Organization',
    'Locations',
    'Meeting',
    'AnnualStatus',
    'WorkplaceAssessment',
    'SafetyInspection',
    'Learning',
    'ActionPlans',
    'ExternalLinks',
    'DocumentArchive',
    'Notifications'
] as const;

export const CreceaOnlyFeatures:ApplicationFeature[] = [
    'Articles', 
    'ArticlesLight',
    'ArticleLandingPage',
    'CustomForms', 
    'Learning',
    'PublicArticles'
];